import React from 'react'
import styles from './styles.module.scss'
import SvgClose from '@/src/assets/svgs/collection/close.svg'
import { Overlay } from '@/src/components/helpers/overlays/overlay'

export default function ShoppingCartHead() {
    return (
        <div className={styles.container}>
            <div onClick={() => Overlay.dismiss()} className={styles.imageArea}>
                <SvgClose />
            </div>
            <b className={`${styles.title} font-lg`}>Minha sacola</b>
        </div>
    )
}
